import PlanboardMode from './PlanboardMode'
import Planner from './Planner'

export default class PlanboardModeChooseDeal extends PlanboardMode {
  constructor(planboard) {
    super(planboard)
    this.planner = new Planner(
      this,
      this.planboard.$elm.find('#planboard-package-selector'),
    )
  }

  start(args) {
    var url = args[0]
    var $modal = $('#briq-modal')

    $modal.modal({ show: true })
    $.ajax({
      url: url,
      success: function(data) {
        $modal
          .find('.modal__body')
          .html(data)
          .trigger('bless')
      },
    })
  }

  stop() {
    this.planboard.$defaultButtons.show()
    this.planboard.$packageSelector.removeClass('active')
    this.planboard.$elm.find('.planboard-slot.selected').removeClass('selected')
    this.planboard.$activityRows.removeClass('planboard__activity--dimmed')
    this.waitingSlot = null
    this.planboard.resetWrapperHeight()
    this.planboard.productGroups = []
  }

  // Enter choose package modus after deal is chosen
  onChoosePackage(formData) {
    var self = this
    var $activeSelector = $('.planboard__package-selector.active')
    $('#briq-modal').modal('hide')
    var packageSelectorUrl = this.planboard.$packageSelector.attr('data-url')
    if ($activeSelector.length) {
      $.get(packageSelectorUrl, formData).then(
        function(value) {
          $activeSelector
            .find('.planboard-package-selector__products')
            .append($(value.html))
          self.planboard.$activityRows.addClass('planboard__activity--dimmed')
          self.planboard.handle('packagechosen', {
            productGroup: value.productGroup,
          })
        },
        function(jqXHR, textStatus, errorThrown) {
          console.log('Loading failed: ' + textStatus)
        },
      )
    } else {
      //TODO: fix this
      console.error('switch mode to choose package here?')
      this.planboard.$defaultButtons.hide()
      this.planboard.$newBookingButtons.hide()
      this.planner.update()
      this.planboard.$packageSelector.addClass('active')
      var $packageSelectorContent = this.planboard.$packageSelector.find(
        '.planboard__package-selector-content',
      )
      $.get(packageSelectorUrl, formData).then(
        function(value) {
          $packageSelectorContent.html(value.html)
          self.planboard.$activityRows.addClass('planboard__activity--dimmed')

          self.planboard.handle('packagechosen', {
            productGroup: value.productGroup,
          })
        },
        function(jqXHR, textStatus, errorThrown) {
          $packageSelectorContent.html(
            `Loading failed: <pre>${textStatus}</pre>`,
          )
        },
      )
    }
  }
}
